//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            detail: JSON.parse(sessionStorage.getItem("data"))
        }
    },
    created() {
        if (this.detail.redirect_url) {
            setTimeout(() => {
                location.replace(this.detail.redirect_url)
            }, 3000);
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/merchantTransfer/result.vue